import { Tooltip } from '@mui/material';
import './SalesCell.css';
import { SalesCellProps } from './SalesCell.types';

/**
 * Renders a sales cell displaying fuel sales metrics with growth indicators
 * Shows current week average, week growth, previous day average, and day growth

 */
export function SalesCell({ sales }: SalesCellProps) {
  if (!sales) return <span></span>;

  return (
    <div className="sales-grid">
      <Tooltip
        title={<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Срдн. реал. по НП за\nпот. тиж.'}</div>}
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.currentWeekAvg
            ? sales.currentWeekAvg.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
            : ''}
        </div>
      </Tooltip>
      <Tooltip
        title={
          <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Приріст поточного до\nминулого тижня'}</div>
        }
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.weekGrowth != null && !!sales.currentWeekAvg ? (
            <span className={sales.weekGrowth > 0 ? 'positive-change' : sales.weekGrowth < 0 ? 'negative-change' : ''}>
              <span>{sales.weekGrowth >= 0 ? '+' : ''}{Number(sales.weekGrowth || 0).toFixed(1)}%</span>
              <span className={`sales-arrow ${sales.weekGrowth > 0 ? 'up' : sales.weekGrowth < 0 ? 'down' : ''}`}>
                {sales.weekGrowth > 0 ? '↑' : sales.weekGrowth < 0 ? '↓' : ''}
              </span>
            </span>
          ) : (
            ''
          )}
        </div>
      </Tooltip>
      <Tooltip
        title={<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Срдн. реал. по НП за\nпопер. день'}</div>}
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.previousDayAvg
            ? sales.previousDayAvg.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
            : ''}
        </div>
      </Tooltip>
      <Tooltip
        title={
          <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
            {'Приріст попер. дня\nдо відповід. дня мин.\nтижня'}
          </div>
        }
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.dayGrowth !== 0 ? (
            <span className={sales.dayGrowth > 0 ? 'positive-change' : 'negative-change'}>
              <span>{sales.dayGrowth >= 0 ? '+' : ''}{Number(sales.dayGrowth || 0).toFixed(1)}%</span>
              <span className={`sales-arrow ${sales.dayGrowth > 0 ? 'up' : 'down'}`}>
                {sales.dayGrowth > 0 ? '↑' : '↓'}
              </span>
            </span>
          ) : (
            ''
          )}
        </div>
      </Tooltip>
    </div>
  );
}
